import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../auth";
import { getApplySpecialProducts } from "./_requests";
import { useLang } from "../../../../../_metronic/i18n/Metronici18n";



export const useCheckPendingBulk = ()=>{
    const {currentUser} = useAuth();
    const language = useLang()
    const navigate = useNavigate()

    useEffect(()=>{
        const checkPendingBulk = async () =>{
            // special_status must match the list the destination page renders.
            // SpecialController@getSpecial returns 'connected product' rows when
            // the param is present and 'pending' rows when it is omitted, and
            // /discount/add-discount-bulk (ConnectedBarcodeDetails) asks for the
            // 'connected product' list. Omitting it here meant a supplier holding
            // only 'pending' rows — a discount added from the selection page and
            // never submitted — was redirected to a page that found nothing and
            // bounced them straight on to /thank-you.
            const {data} = await getApplySpecialProducts(currentUser?.token, language, {
                special_status: 1,
            })
            // if list is empty, return the cycle
            if (data && data.hasOwnProperty('special_list') &&  data.special_list?.length > 0) {
                navigate(`/discount/add-discount-bulk?from=${document.location.pathname}`)
            }
        }
        
        checkPendingBulk()
    },[])
}
